import styled, { css } from 'styled-components';

export const RelativeWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        background: transparent
            linear-gradient(
                270deg,
                ${theme.colors.campaigns.clearing.primary.hex} 0%,
                ${theme.colors.accents[30].hex} 100%
            )
            0% 0% no-repeat padding-box;
        border-bottom: ${theme.commonStyles.brandPixel} solid
            ${theme.colors.campaigns.clearing.primaryContrast.hex};
        width: 100%;
        overflow: hidden;
        padding: 0.75rem 0;
    `}
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        gap: 1.5rem;

        @media ${theme.breakpoints.xlarge.media} {
            padding-left: 10rem;
        }

        @media ${theme.breakpoints.huge.media} {
            padding-left: 7rem;
        }

        @media ${theme.breakpoints.giant.media} {
            padding-left: 2rem;
        }
    `}
`;

export const ListWrapper = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 0;
    margin: 0;

    li:last-of-type {
        display: flex;

        span,
        a {
            white-space: nowrap;
            font-weight: bold;
            text-decoration: underline;
            color: ${({ theme }) => theme.colors.campaigns.clearing.primaryContrast.hex};
            padding: 0.75rem 0.5rem;
            font-size: 1.125rem;
            align-self: center;
        }
    }
`;

export const StatusTextWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const ClearingStatusText = styled.p`
    ${({ theme }) => css`
        font-size: 0.875rem;
        line-height: 1.2;
        margin: 0;
        font-weight: 900;
        font-family: ${theme.fonts.secondary};
        font-style: italic;
        color: ${theme.colors.campaigns.clearing.primaryContrast.hex};

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const StyledListItem = styled.li`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: list-item;
        }
    `}
`;

export const ColWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: row;
        gap: 1rem;

        @media ${theme.breakpoints.medium.media} {
            gap: 5rem;
        }
    `}
`;
